<template>
  <div>

    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Live Webinar</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Marketing</b> /
      <b>Webinar</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">

          <add-webinar></add-webinar>

        </div>


        <div class="card text-left mt-2">
          <div class="card-body">
            <table-archive></table-archive>
          </div>
        </div>
      </div>
    </div>
  </div>

  
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getRequest, postRequest } from "@/services/RequestService";
import AddWebinar from "./add.vue";
import TableArchive from "./archiveTable.vue";

export default {
  name: "award-points",
  components: { Pagination, AddWebinar, TableArchive},

  data() {
    return {
      points: [],
      _api: `/award/individual`,
      _sign: '?',
      downloadApi: ``,

      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0
      },

      date_from: null,
      date_to: null,
      search: null,

      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Pending" },
        { status: false, name: "Approved" },
        { status: false, name: "Rejected" }
      ],

      all: true,
      pending: false,
      approved: false,
      rejected: false,
      individualStatus: 'all',

      checkUser: false,

      reject_remarks: null,
      awardPoint: 0,
      awardId: null,
    };
  },

  async created() {
  },

};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}


</style>./archiveTable.vue
